<template>
    <svg
        :class="design"
        :width="width"
        :height="height"
        viewBox="0 0 28 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M22.7143 0H18.4286C17.7214 0 17.1429 0.578571 17.1429 1.28571V5.57143C17.1429 6.27857 17.7214 6.85714 18.4286 6.85714H22.7143C23.4214 6.85714 24 6.27857 24 5.57143V1.28571C24 0.578571 23.4214 0 22.7143 0ZM22.2857 5.14286H18.8571V1.71429H22.2857V5.14286ZM14.1429 0H9.85714C9.15 0 8.57143 0.578571 8.57143 1.28571V5.57143C8.57143 6.27857 9.15 6.85714 9.85714 6.85714H14.1429C14.85 6.85714 15.4286 6.27857 15.4286 5.57143V1.28571C15.4286 0.578571 14.85 0 14.1429 0ZM13.7143 5.14286H10.2857V1.71429H13.7143V5.14286ZM5.57143 0H1.28571C0.578571 0 0 0.578571 0 1.28571V5.57143C0 6.27857 0.578571 6.85714 1.28571 6.85714H5.57143C6.27857 6.85714 6.85714 6.27857 6.85714 5.57143V1.28571C6.85714 0.578571 6.27857 0 5.57143 0ZM5.14286 5.14286H1.71429V1.71429H5.14286V5.14286ZM22.7143 10.2857H18.4286C17.7214 10.2857 17.1429 10.8643 17.1429 11.5714V15.8571C17.1429 16.5643 17.7214 17.1429 18.4286 17.1429H22.7143C23.4214 17.1429 24 16.5643 24 15.8571V11.5714C24 10.8643 23.4214 10.2857 22.7143 10.2857ZM22.2857 15.4286H18.8571V12H22.2857V15.4286ZM14.1429 10.2857H9.85714C9.15 10.2857 8.57143 10.8643 8.57143 11.5714V15.8571C8.57143 16.5643 9.15 17.1429 9.85714 17.1429H14.1429C14.85 17.1429 15.4286 16.5643 15.4286 15.8571V11.5714C15.4286 10.8643 14.85 10.2857 14.1429 10.2857ZM13.7143 15.4286H10.2857V12H13.7143V15.4286ZM5.57143 10.2857H1.28571C0.578571 10.2857 0 10.8643 0 11.5714V15.8571C0 16.5643 0.578571 17.1429 1.28571 17.1429H5.57143C6.27857 17.1429 6.85714 16.5643 6.85714 15.8571V11.5714C6.85714 10.8643 6.27857 10.2857 5.57143 10.2857ZM5.14286 15.4286H1.71429V12H5.14286V15.4286Z"
            :fill="fill"/>
    </svg>
</template>
<script>

export default {
    name: 'ui-square-th',

    props: {
        fill: {
            type: String,
            default: '#0091FF'
        },
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 28
        },
        height: {
            type: [String, Number],
            default: 22
        }
    }
}
</script>